import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Store } from '../Store';

export default function HelpDeskProtectedRoute({ children }) {
  const { state } = useContext(Store);
  const { userInfo } = state;

  return userInfo && userInfo.isHelpDesk && !userInfo.client ? (
    children
  ) : userInfo && userInfo.isHelpDesk && userInfo.client ? (
    <Navigate to={`/category/order`} />
  ) : userInfo && userInfo.isCustomer ? (
    <Navigate to={`/qrmenu?code=${userInfo.code}`} />
  ) : (
    <Navigate to="/signin" />
  );
}
